import React from 'react'


export const About = () => {
    return (
        <div className="jumbotron jumbotron-fluid">
            <div className="container">
                <h1 className="display-4">Обычное todo</h1>
                <p className="lead">Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque eius ipsum obcaecati molestias cumque quasi a. Fuga, quia sequi numquam quos itaque perferendis similique cupiditate, deleniti molestiae beatae assumenda molestias!</p>
            </div>
        </div>
    )
}
